import { render, staticRenderFns } from "./email-profile.vue?vue&type=template&id=89063460&scoped=true"
import script from "./email-profile.vue?vue&type=script&lang=js"
export * from "./email-profile.vue?vue&type=script&lang=js"
import style0 from "./email-profile.vue?vue&type=style&index=0&id=89063460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89063460",
  null
  
)

export default component.exports